import React, { useState, useCallback } from 'react';
import { faq } from '../utils/contentProvider';

export const Faq = () => {
  const [faqActive, setFaqActive] = useState(null);

  const toggleFaqAccordion = useCallback(
    (id) => () => {
      setFaqActive((state) => (id === state ? null : id));
    },
    [],
  );

  return (
    <section className="faq">
      <div className="small-container">
        <div className="faq-head">
          <h5 className="yellow-heading text-center">Important Questions</h5>
          <h3 className="text-center">Have Any Questions?</h3>
          <p className="text-center">
            Below are frequently asked questions by employers finding talent
            with ClipHire.
          </p>
        </div>
        <div className="faq-content position-relative">
          <div className="position-absolute">
            <span className="big-gradient-circle gradient-anim red-gradient" />
            <span className="big-gradient-circle gradient-anim delay-1 " />
            <span className="big-gradient-circle gradient-anim delay-2 green-gradient" />
          </div>
          {faq.map(({ id, q, a }) => (
            <div
              key={id}
              className={`accordion flex-row no-margin${
                faqActive === id ? ' is-active' : ''
              }`}>
              <button
                type="button"
                className="button-unstyled accordion-head"
                onClick={toggleFaqAccordion(id)}>
                <div className="flex-row no-margin align-items-center">
                  <h5>{q}</h5>
                </div>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 1.5l5 5 5-5"
                    stroke="#000"
                    strokeWidth="1.667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="accordion-body">
                <p>{a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
